module.exports = __webpack_public_path__ + "img/yljkg.72ec987f.png";